import { useTranslation } from 'react-i18next';
import './ProductBadge.scss';
import { FC } from 'react';

type ProductBadgeProps = {
  floating?: boolean;
  forSale: boolean | undefined;
  variant?: 'text' | 'box';
};

export const ProductBadge: FC<ProductBadgeProps> = ({
  forSale,
  floating,
  variant = 'text',
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`product-badge ${floating ? 'product-badge-floating' : ''} product-badge-variant-${variant}`}
    >
      <ul>
        {!forSale && <li className='sale-badg'>{t('aimSelect.forRent')}</li>}
        {forSale && <li className='sale-badg'>{t('aimSelect.forSale')}</li>}
      </ul>
    </div>
  );
};
